import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcCredSSPOperation, RpcCredSSPOperationResult, RpcCredSspRequestKey } from './rpc-credssp-model';

export class RpcCredSspRequestClient {
    /**
     * The CredSsp request command.
     *
     * @param data the RpcCredSSPOperation object.
     * @return Promise<RpcCredSSPOperationResult> the promise object.
     */
    public static credSspRequest(rpc: Rpc, data: RpcCredSSPOperation): Promise<RpcCredSSPOperationResult> {
        return RpcInboundClient.call(rpc, RpcCredSspRequestKey.command, RpcCredSspRequestKey.version, data);
    }
}
